import { usePlayer } from "../../player/context.js";
import { SliderSegments } from "./segments.js";
import { TimeSliderChapterCSSVars, TimeSliderChapterDataAttrs, TimeSliderChaptersCore } from "@videojs/core";
import { getStateDataAttrs, selectBuffer, selectTextTrack, selectTime } from "@videojs/core/dom";
import { forwardRef, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
import { isFunction } from "@videojs/utils/predicate";
//#region src/ui/time-slider/chapters.tsx
/** Renders normalized chapter ranges across the full slider, including one full range when chapter cues are absent. */
const TimeSliderChapters = forwardRef(function TimeSliderChapters(componentProps, ref) {
	const { renderChapter, className, style, render, ...props } = componentProps;
	const textTrack = usePlayer(selectTextTrack);
	const buffer = usePlayer(selectBuffer);
	const duration = usePlayer(selectTime)?.duration ?? 0;
	const [core] = useState(() => new TimeSliderChaptersCore());
	const { chapters, ranges, max } = useMemo(() => core.getRanges(textTrack?.chaptersCues ?? [], 0, duration), [
		core,
		textTrack?.chaptersCues,
		duration
	]);
	const bufferedEnd = buffer?.buffered.length ? buffer.buffered[buffer.buffered.length - 1][1] : 0;
	const getChapterState = (segment) => core.getState(segment, chapters, bufferedEnd);
	const state = useMemo(() => ({ chapters }), [chapters]);
	return /* @__PURE__ */ jsx(SliderSegments, {
		ref,
		...props,
		className: isFunction(className) ? className(state) : className,
		style: isFunction(style) ? style(state) : style,
		render: isFunction(render) ? (renderProps) => render(renderProps, state) : render,
		ranges,
		min: 0,
		max,
		renderSegment: (segmentProps, segment) => {
			const state = getChapterState(segment);
			const chapterProps = {
				...segmentProps,
				...getStateDataAttrs(state, TimeSliderChapterDataAttrs),
				style: {
					...segmentProps.style,
					pointerEvents: state.cue ? void 0 : "none",
					[TimeSliderChapterCSSVars.buffer]: `${state.bufferPercent}%`
				}
			};
			return renderChapter(chapterProps, state);
		}
	});
});
//#endregion
export { TimeSliderChapters };

//# sourceMappingURL=chapters.js.map